import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const ColumnsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${props => props.theme.spacing.sp24};
`

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.secondary};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.secondary};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`
